import React, { useState, useEffect } from 'react';
import axios from 'axios';

import SearchForm from './Components/SearchForm';
import Features from './Components/Features';
import Chart from './Components/Chart';

const serviceUrl = 'https://spotify-web-api-token-generator-bmv7tpwvj.now.sh';
const chartDataKeys = [
  'danceability',
  'energy',
  'speechiness',
  'acousticness',
  'instrumentalness',
  'liveness',
  'valence'
];

const featuresDataKeys = ['loudness', 'tempo', 'key', 'time_signature'];

export default () => {
  const [token, setToken] = useState();
  const [query, setQuery] = useState();
  const [searchResult, setSearchResult] = useState();
  const [chartFeatures, setChartFeatures] = useState();
  const [features, setFeatures] = useState();

  const getToken = async () => {
    const response = await axios.get(`${serviceUrl}/token`);
    setToken(response.data.token);
  };

  useEffect(() => {
    getToken();
  }, []);

  useEffect(() => {
    if (token && query) {
      const getTrackFeatures = async (token, query) => {
        const searchResult = await axios.get(
          'https://api.spotify.com/v1/search',
          {
            params: { q: query, type: 'track', limit: 1 },
            headers: { Authorization: `Bearer ${token}` }
          }
        );

        if (!searchResult.data.tracks.items.length) return;
        const track = searchResult.data.tracks.items[0];
        setSearchResult(track);

        const featuresResult = await axios.get(
          `https://api.spotify.com/v1/audio-features/${track.id}`,
          {
            params: { q: query, type: 'track', limit: 1 },
            headers: { Authorization: `Bearer ${token}` }
          }
        );

        const chartData = Object.keys(featuresResult.data).reduce(
          (res, k) =>
            chartDataKeys.includes(k)
              ? [...res, { name: k, value: featuresResult.data[k] }]
              : res,
          []
        );

        setChartFeatures(chartData);

        const featuresData = Object.keys(featuresResult.data).reduce(
          (res, k) =>
            featuresDataKeys.includes(k)
              ? { ...res, [k]: featuresResult.data[k] }
              : res,
          {}
        );

        setFeatures(featuresData);
      };

      getTrackFeatures(token, query);
    }
  }, [token, query]);

  return (
    <div className="App">
      <h1>Beat Detect</h1>
      <SearchForm onSearch={setQuery} />

      {features && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
          <Features data={features} />
          <Chart data={chartFeatures} />
          <iframe
            title="spotify_player"
            src={`https://open.spotify.com/embed/track/${searchResult.id}`}
            width="300"
            height="380"
            frameborder="0"
            allowtransparency="true"
            allow="encrypted-media"
          />
        </div>
      )}
    </div>
  );
};
